export function formatDateStr(dateString){
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = '00';
  const minutes = '00';
  const seconds = '00';
  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function formatNumber(number){
  const num = Number(number);
  if (isNaN(num)) {
    return number;
  }
  return num.toLocaleString('id-ID');
}

/**
 * Mask account number for e-wallets and bank accounts
 * @param {string} accountNumber - The account number to mask
 * @param {string} bank - The bank name
 * @returns {string} Masked account number or original if not maskable
 */
export function maskAccountNumber(accountNumber, bank) {
  // Only mask if account number and bank exist
  if (!accountNumber || !bank) {
    return accountNumber;
  }
  
  const bankLower = bank.toLowerCase();
  
  // E-wallets that use phone numbers (show first 2 and last 2 digits)
  const eWalletBanks = ['dana', 'gopay', 'ovo', 'shopee'];
  
  // Traditional banks (show first 4 and last 4 digits)
  const traditionalBanks = [
    'bca', 'bank central asia', 'bni', 'bank negara indonesia', 
    'bri', 'bank rakyat indonesia', 'mandiri', 'bank mandiri',
    'permata', 'bank permata', 'cimb', 'bank cimb niaga',
    'hsbc', 'bank hsbc', 'citibank', 'bank citibank',
    'danamon', 'bank danamon', 'maybank', 'bank maybank',
    'ocbc', 'bank ocbc', 'uob', 'bank uob', 'btpn', 'bank btpn',
    'mega', 'bank mega', 'sinarmas', 'bank sinarmas',
    'bukopin', 'bank bukopin', 'bca syariah', 'bank bca syariah'
  ];
  
  // If account number is too short, don't mask
  if (accountNumber.length < 4) {
    return accountNumber;
  }
  
  // Check if it's an e-wallet (phone number format)
  if (eWalletBanks.includes(bankLower)) {
    // For e-wallets (phone numbers), show first 2 and last 2 digits
    // Example: 08123456789 -> 08*******89
    if (accountNumber.length < 4) {
      return accountNumber;
    }
    const firstTwo = accountNumber.substring(0, 2);
    const lastTwo = accountNumber.substring(accountNumber.length - 2);
    const middleMask = '*'.repeat(accountNumber.length - 4);
    return `${firstTwo}${middleMask}${lastTwo}`;
  }
  
  // Check if it's a traditional bank
  if (traditionalBanks.includes(bankLower)) {
    // For bank accounts, show first 4 and last 4 digits
    // Example: 1234567890 -> 1234**7890
    if (accountNumber.length < 8) {
      return accountNumber;
    }
    const firstFour = accountNumber.substring(0, 4);
    const lastFour = accountNumber.substring(accountNumber.length - 4);
    const middleMask = '*'.repeat(accountNumber.length - 8);
    return `${firstFour}${middleMask}${lastFour}`;
  }
  
  // For any other bank not in the list, also mask (conservative approach)
  // Show first 4 and last 4 digits
  if (accountNumber.length >= 8) {
    const firstFour = accountNumber.substring(0, 4);
    const lastFour = accountNumber.substring(accountNumber.length - 4);
    const middleMask = '*'.repeat(accountNumber.length - 8);
    return `${firstFour}${middleMask}${lastFour}`;
  } else if (accountNumber.length >= 4) {
    const firstTwo = accountNumber.substring(0, 2);
    const lastTwo = accountNumber.substring(accountNumber.length - 2);
    const middleMask = '*'.repeat(accountNumber.length - 4);
    return `${firstTwo}${middleMask}${lastTwo}`;
  }
  
  return accountNumber;
}